// commonServices.js
// Funzioni condivise tra le varie aree/ruoli

import apiClient from './apiClient';

export const fetchAnnouncements = async () => {
    const response = await apiClient.get('/announcements.php?action=fetch');
    return response.data;
};

export const fetchCommunications = async () => {
    const response = await apiClient.get('/communications.php?action=fetch');
    return response.data;
};

export const fetchGuests = async () => {
    const response = await apiClient.get('/guests.php');
    return response.data;
};

export const fetchCollaborators = async () => {
    const response = await apiClient.get('/collaborators.php');
    return response.data;
};

export const fetchAttachmentsDirector = async () => {
    const response = await apiClient.get('/attachments.php');
    return response.data;
};

export const fetchAttachmentsEducator = async () => {
    const response = await apiClient.get('/attachments.php?action=getVisible');
    return response.data;
};

export const fetchDiaryEntries = async (date) => {
    try {
        if (date) {
            const d = new Date(date);
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            const day = `${yyyy}-${mm}-${dd}`;
            const response = await apiClient.get(`/diario.php?action=getByDate&date=${day}`);
            return response.data;
        }
        const response = await apiClient.get('/diario.php?action=getAll');
        return response.data;
    } catch (err) {
        console.error('Errore fetchDiaryEntries:', err);
        throw err;
    }
};
